/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/

/** Import ENVIRONMENTAL VARIABLES */
import ENV from "react-dotenv";

import React, {useContext, useEffect, useState} from "react";

import {useDispatch} from "react-redux";
import CHANGE_API_REQUEST_STATUS_ACTION from "@Actions/Interface/ChangeApiRequestStatus";
import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";

import ApplicationApiContext from "@Contexts/Api";

import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";


import {Helmet} from "react-helmet";


import {Col} from "react-bootstrap";


import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";


import BlockContentContainerComponent from "@Components/UI/Containers/Block";
import BlockContentHeaderComponent from "@Components/UI/Containers/Block/Header";


import TerminalsListComponent from "@UIPages/Authenticated/Terminals/List/Terminals";
import TerminalsListLegendComponent from "@UIPages/Authenticated/Terminals/List/Legend";


import DEFAULT_REQUEST_HEADERS from "@Services/Interfaces/Http/Request/Headers";

import HTTP_ERROR_RESPONSE_INTERFACE from "@Services/Interfaces/Http/Response/Error";
import ERROR_SYSTEM_MESSAGE_INTERFACE from "@Services/Application/Interfaces/_Messages/Errors";

import TERMINAL_INTERFACE from "@Services/Application/Interfaces/Terminals/Terminal";
import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";
import REST_API_REQUEST from "@Services/Utilities/Requests";
import CHANGE_API_REQUEST_TOKEN_ACTION from "@Actions/Api/ChangeApiRequestTokenValue";
import prepareRestApiRequestToken from "@Services/Utilities/RequestToken/Prepare";


type DispositionsTerminalsListPageProps = {};


export const DispositionsTerminalsListPageComponent: React.FC<DispositionsTerminalsListPageProps> = (): JSX.Element | null => {


    const DISPATCHER = useDispatch();


    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state):ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    /** @const {object} INTERFACE_DATA - Application State Store Interface Data */
    const INTERFACE_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.interface
    );

    /** @const {boolean} REST_API_REQUEST_STATUS - Application Global State Rest Api Request Status */
    const REST_API_REQUEST_STATUS: boolean = INTERFACE_DATA?.apiRequestStatus || false;

    /** @const {string} Global Rest Api Root URL Address */
    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL || null;


    /** @const {object} REST_API_DATA - Application State Store Rest Api Data */
    const REST_API_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.api
    );

    /** @const {} REST_API_REQUEST_TOKEN - Application Rest Api Request Token */
    const REST_API_REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE = REST_API_DATA?.requestToken || null;


    const [DISPOSITIONS_TERMINALS, SET_DISPOSITIONS_TERMINALS] = useState<TERMINAL_INTERFACE[]>([]);
    const [DISPOSITIONS_TERMINALS_ERROR, SET_DISPOSITIONS_TERMINALS_ERROR] = useState<ERROR_SYSTEM_MESSAGE_INTERFACE | null>(null);

    useEffect(() => {

        if (!REST_API_URL || !LOGGED_USER?.userID) return;

        const DISPOSITIONS_TERMINALS_API_URL = REST_API_URL + "/Terminal/List";

        const DISPOSITIONS_TERMINALS_REQUEST_DATA = {
            UserId: LOGGED_USER?.userID,
            Favorite: false,
            Mode: "D"
        }

        const GET_DISPOSITIONS_LIST_PAGE_DATA = async (): Promise<any> => {

            DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(true));

            try {

                const DISPOSITIONS_RESPONSE = await REST_API_REQUEST(
                    DISPOSITIONS_TERMINALS_API_URL,
                    DISPOSITIONS_TERMINALS_REQUEST_DATA,
                    REST_API_REQUEST_TOKEN
                );

                if (DISPOSITIONS_RESPONSE.status === 200) {
                    const CONTENT: {Terminals: TERMINAL_INTERFACE[]} = await DISPOSITIONS_RESPONSE.json();
                    SET_DISPOSITIONS_TERMINALS(CONTENT?.Terminals);
                } else {
                    const CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = await DISPOSITIONS_RESPONSE.json();
                    SET_DISPOSITIONS_TERMINALS_ERROR({ErrorCode: DISPOSITIONS_RESPONSE.status, UserMessage: CONTENT.UserMessage});
                }

            } catch (e) {
                SET_DISPOSITIONS_TERMINALS_ERROR({ErrorCode: 500, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"});
            }

            DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(false));

        };

        GET_DISPOSITIONS_LIST_PAGE_DATA();

        return () => {};

    }, [REST_API_URL]);


    useEffect(() => {
        return () => {
            SET_DISPOSITIONS_TERMINALS([]);
            SET_DISPOSITIONS_TERMINALS_ERROR(null);
        };
    }, []);


    if (!LOGGED_USER || !LOGGED_USER?.userID) return null;


    const ACTIVE_TERMINALS = DISPOSITIONS_TERMINALS.filter(
        (terminal: TERMINAL_INTERFACE) => !!terminal?.DispCount
    );

    const FAVORITE_TERMINALS = ACTIVE_TERMINALS.filter(
        (terminal: TERMINAL_INTERFACE) => !!terminal.Favorite
    );

    const OTHER_TERMINALS = ACTIVE_TERMINALS.filter(
        (terminal: TERMINAL_INTERFACE) => !terminal.Favorite
    );


    return (
        <BlockContentContainerComponent cssClasses={"dispositions-list-page-component"}>

            <BlockContentHeaderComponent headerText={`Moje Dyspozycje`} />

            {/* Helmet Module Component - Set Document Title */}
            <Helmet>
                <title>{`${ENV.APP_TITLE} - Moje dyspozycje`}</title>
            </Helmet>
            {/* /Helmet Module Component - Set Document Title */}

            {!!DISPOSITIONS_TERMINALS_ERROR ?

            <ErrorMessageComponent messageText={DISPOSITIONS_TERMINALS_ERROR.UserMessage}/>

            :

            ACTIVE_TERMINALS.length > 0 ?
            <>

            <TerminalsListComponent TERMINALS={FAVORITE_TERMINALS} TERMINALS_LIST_TYPE={"DISPOSITIONS"} FAVORITE={true} />

            <TerminalsListComponent TERMINALS={OTHER_TERMINALS} TERMINALS_LIST_TYPE={"DISPOSITIONS"} FAVORITE={false} />

            <TerminalsListLegendComponent TERMINALS_LIST_TYPE={"DISPOSITIONS"} />

            </>
            :

            !REST_API_REQUEST_STATUS &&
            <Col xs={12} className={"no-list-elements-message default-system-message"}>
                <span>{`Nie masz żadnych Dyspozycji`}</span>
            </Col>

            }

        </BlockContentContainerComponent>
    );

};


export default DispositionsTerminalsListPageComponent;
